// import track icons for map
import mario_bros_circuit from "../mkworld-assets/tracks/mario_bros_circuit.webp"
import crown_city from "../mkworld-assets/tracks/crown_city.png"
import whistlestop_summit from "../mkworld-assets/tracks/whistlestop_summit.webp"
import dk_spaceport from "../mkworld-assets/tracks/dk_spaceport.png"
import desert_hills from "../mkworld-assets/tracks/desert_hills.webp"
import shy_guy_bazaar from "../mkworld-assets/tracks/shy_guy_bazaar.webp"
import wario_stadium from "../mkworld-assets/tracks/wario_stadium.webp"
import airship_fortress from "../mkworld-assets/tracks/airship_fortress.png"
import dk_pass from "../mkworld-assets/tracks/dk_pass.webp"
import starview_peak from "../mkworld-assets/tracks/starview_peak.webp"
import sky_high_sundae from "../mkworld-assets/tracks/sky_high_sundae.webp"
import wario_shipyard from "../mkworld-assets/tracks/wario_shipyard.webp"
import koopa_troopa_beach from "../mkworld-assets/tracks/koopa_troopa_beach.webp"
import faraway_oasis from "../mkworld-assets/tracks/faraway_oasis.webp"
import peach_stadium from "../mkworld-assets/tracks/peach_stadium.webp"
import peach_beach from "../mkworld-assets/tracks/peach_beach.webp"
import salty_salty_speedway from "../mkworld-assets/tracks/salty_salty_speedway.webp"
import dino_dino_jungle from "../mkworld-assets/tracks/dino_dino_jungle.webp"
import great_question_block_ruins from "../mkworld-assets/tracks/great_question_block_ruins.webp"
import cheep_cheep_falls from "../mkworld-assets/tracks/cheep_cheep_falls.webp"
import dandelion_depths from "../mkworld-assets/tracks/dandelion_depths.webp"
import boo_cinema from "../mkworld-assets/tracks/boo_cinema.webp"
import dry_bones_burnout from "../mkworld-assets/tracks/dry_bones_burnout.webp"
import moo_moo_meadows from "../mkworld-assets/tracks/moo_moo_meadows.webp"
import choco_mountain from "../mkworld-assets/tracks/choco_mountain.webp"
import toads_factory from "../mkworld-assets/tracks/toads_factory.webp"
import bowsers_castle from "../mkworld-assets/tracks/bowsers_castle.webp"
import acorn_heights from "../mkworld-assets/tracks/acorn_heights.webp"
import mario_circuit from "../mkworld-assets/tracks/mario_circuit.webp"
import rainbow_road from "../mkworld-assets/tracks/rainbow_road.webp"

// import courseimg shown in track selection
import mario_bros_circuit_img from "../mkworld-assets/courseimg/mario_bros_circuit.webp"
import crown_city_img from "../mkworld-assets/courseimg/crown_city.webp"
import whistlestop_summit_img from "../mkworld-assets/courseimg/whistlestop_summit.webp"
import dk_spaceport_img from "../mkworld-assets/courseimg/dk_spaceport.webp"
import desert_hills_img from "../mkworld-assets/courseimg/desert_hills.webp"
import shy_guy_bazaar_img from "../mkworld-assets/courseimg/shy_guy_bazaar.webp"
import wario_stadium_img from "../mkworld-assets/courseimg/wario_stadium.webp"
import airship_fortress_img from "../mkworld-assets/courseimg/airship_fortress.webp"
import dk_pass_img from "../mkworld-assets/courseimg/dk_pass.webp"
import starview_peak_img from "../mkworld-assets/courseimg/starview_peak.webp"
import sky_high_sundae_img from "../mkworld-assets/courseimg/sky_high_sundae.webp"
import wario_shipyard_img from "../mkworld-assets/courseimg/wario_shipyard.webp"
import koopa_troopa_beach_img from "../mkworld-assets/courseimg/koopa_troopa_beach.webp"
import faraway_oasis_img from "../mkworld-assets/courseimg/faraway_oasis.webp"
import peach_stadium_img from "../mkworld-assets/courseimg/peach_stadium.webp"
import peach_beach_img from "../mkworld-assets/courseimg/peach_beach.webp"
import salty_salty_speedway_img from "../mkworld-assets/courseimg/salty_salty_speedway.webp"
import dino_dino_jungle_img from "../mkworld-assets/courseimg/dino_dino_jungle.webp"
import great_question_block_ruins_img from "../mkworld-assets/courseimg/great_question_block_ruins.webp"
import cheep_cheep_falls_img from "../mkworld-assets/courseimg/cheep_cheep_falls.webp"
import dandelion_depths_img from "../mkworld-assets/courseimg/dandelion_depths.webp"
import boo_cinema_img from "../mkworld-assets/courseimg/boo_cinema.webp"
import dry_bones_burnout_img from "../mkworld-assets/courseimg/dry_bones_burnout.webp"
import moo_moo_meadows_img from "../mkworld-assets/courseimg/moo_moo_meadows.webp"
import choco_mountain_img from "../mkworld-assets/courseimg/choco_mountain.webp"
import toads_factory_img from "../mkworld-assets/courseimg/toads_factory.webp"
import bowsers_castle_img from "../mkworld-assets/courseimg/bowsers_castle.webp"
import acorn_heights_img from "../mkworld-assets/courseimg/acorn_heights.webp"
import mario_circuit_img from "../mkworld-assets/courseimg/mario_circuit.webp"
import rainbow_road_img from "../mkworld-assets/courseimg/rainbow_road.webp"

const track_list = [
    {
        id: "mario_bros_circuit",
        name: "Mario Bros. Circuit",
        icon: mario_bros_circuit,
        courseimg: mario_bros_circuit_img,
        pos: { x: 25, y: 59 },
        connections: ["wario_stadium", "toads_factory", "choco_mountain", "crown_city", "whistlestop_summit", "desert_hills", "shy_guy_bazaar"]
    },
    {
        id: "crown_city",
        name: "Crown City",
        icon: crown_city,
        courseimg: crown_city_img,
        pos: { x: 35.5, y: 71.5 },
        connections: ["choco_mountain", "moo_moo_meadows", "peach_stadium", "faraway_oasis", "koopa_troopa_beach", "dk_spaceport", "whistlestop_summit", "desert_hills",
            "mario_bros_circuit", "wario_stadium"]
    },
    {
        id: "whistlestop_summit",
        name: "Whistlestop Summit",
        icon: whistlestop_summit,
        courseimg: whistlestop_summit_img,
        pos: { x: 23.75, y: 79 },
        connections: ["desert_hills", "mario_bros_circuit", "choco_mountain", "crown_city", "koopa_troopa_beach", "dk_spaceport"]
    },
    {
        id: "dk_spaceport",
        name: "DK Spaceport",
        icon: dk_spaceport,
        courseimg: dk_spaceport_img,
        pos: { x: 37.5, y: 83.75 },
        connections: ["whistlestop_summit", "desert_hills", "mario_bros_circuit", "crown_city", "peach_stadium", "koopa_troopa_beach"]
    },
    {
        id: "desert_hills",
        name: "Desert Hills",
        icon: desert_hills,
        courseimg: desert_hills_img,
        pos: { x: 13.5, y: 68 },
        connections: ["shy_guy_bazaar", "mario_bros_circuit", "crown_city", "koopa_troopa_beach", "whistlestop_summit"]

    },
    {
        id: "shy_guy_bazaar",
        name: "Shy Guy Bazaar",
        icon: shy_guy_bazaar,
        courseimg: shy_guy_bazaar_img,
        pos: { x: 13.125, y: 49.375 },
        connections: ["airship_fortress", "wario_stadium", "choco_mountain", "mario_bros_circuit", "desert_hills"]
    },
    {
        id: "wario_stadium",
        name: "Wario Stadium",
        icon: wario_stadium,
        courseimg: wario_stadium_img,
        pos: { x: 26.25, y: 43.5 },
        connections: ["bowsers_castle", "dry_bones_burnout", "toads_factory", "choco_mountain", "crown_city", "mario_bros_circuit", "shy_guy_bazaar", "airship_fortress"]
    },
    {
        id: "airship_fortress",
        name: "Airship Fortress",
        icon: airship_fortress,
        courseimg: airship_fortress_img,
        pos: { x: 15, y: 31.75 },
        connections: ["bowsers_castle", "dry_bones_burnout", "toads_factory", "wario_stadium", "shy_guy_bazaar"]
    },
    {
        id: "dk_pass",
        name: "DK Pass",
        icon: dk_pass,
        courseimg: dk_pass_img,
        pos: { x: 72.5, y: 43.5 },
        connections: ["starview_peak", "sky_high_sundae", "wario_shipyard", "salty_salty_speedway", "cheep_cheep_falls", "moo_moo_meadows", "dandelion_depths"]
    },
    {
        id: "starview_peak",
        name: "Starview Peak",
        icon: starview_peak,
        courseimg: starview_peak_img,
        pos: { x: 73.375, y: 23.5 },
        connections: ["sky_high_sundae", "wario_shipyard", "dk_pass", "cheep_cheep_falls", "dandelion_depths", "mario_circuit", "boo_cinema"]
    },
    {
        id: "sky_high_sundae",
        name: "Sky-High Sundae",
        icon: sky_high_sundae,
        courseimg: sky_high_sundae_img,
        pos: { x: 84.375, y: 35 },
        connections: ["wario_shipyard", "salty_salty_speedway", "dk_pass", "cheep_cheep_falls", "dandelion_depths", "starview_peak"]
    },
    {
        id: "wario_shipyard",
        name: "Wario Shipyard",
        icon: wario_shipyard,
        courseimg: wario_shipyard_img,
        pos: { x: 85.375, y: 53.25 },
        connections: ["peach_beach", "salty_salty_speedway", "cheep_cheep_falls", "dk_pass", "starview_peak", "sky_high_sundae"]
    },
    {
        id: "koopa_troopa_beach",
        name: "Koopa Troopa Beach",
        icon: koopa_troopa_beach,
        courseimg: koopa_troopa_beach_img,
        pos: { x: 50, y: 80.5 },
        connections: ["dk_spaceport", "crown_city", "peach_stadium", "faraway_oasis", "dino_dino_jungle"]
    },
    {
        id: "faraway_oasis",
        name: "Faraway Oasis",
        icon: faraway_oasis,
        courseimg: faraway_oasis_img,
        pos: { x: 62.5, y: 67.875 },
        connections: ["cheep_cheep_falls", "salty_salty_speedway", "peach_beach", "great_question_block_ruins", "dino_dino_jungle", "koopa_troopa_beach", "crown_city", "peach_stadium"]
    },
    {
        id: "peach_beach",
        name: "Peach Beach",
        icon: peach_beach,
        courseimg: peach_beach_img,
        pos: { x: 84.75, y: 68.5 },
        connections: ["great_question_block_ruins", "dino_dino_jungle", "faraway_oasis", "salty_salty_speedway", "wario_shipyard"]
    },
    {
        id: "salty_salty_speedway",
        name: "Salty Salty Speedway",
        icon: salty_salty_speedway,
        courseimg: salty_salty_speedway_img,
        pos: { x: 73.75, y: 60.5 },
        connections: ["dk_pass", "wario_shipyard", "peach_beach", "great_question_block_ruins", "dino_dino_jungle", "faraway_oasis", "cheep_cheep_falls"]
    },
    {
        id: "dino_dino_jungle",
        name: "Dino Dino Jungle",
        icon: dino_dino_jungle,
        courseimg: dino_dino_jungle_img,
        pos: { x: 64, y: 86 },
        connections: ["koopa_troopa_beach", "faraway_oasis", "salty_salty_speedway", "peach_beach", "great_question_block_ruins"]
    },
    {
        id: "great_question_block_ruins",
        name: "Great ? Block Ruins",
        icon: great_question_block_ruins,
        courseimg: great_question_block_ruins_img,
        pos: { x: 77, y: 80 },
        connections: ["dino_dino_jungle", "koopa_troopa_beach", "faraway_oasis", "salty_salty_speedway", "peach_beach"]
    },
    {
        id: "cheep_cheep_falls",
        name: "Cheep Cheep Falls",
        icon: cheep_cheep_falls,
        courseimg: cheep_cheep_falls_img,
        pos: { x: 62.875, y: 52.1 },
        connections: ["dandelion_depths", "starview_peak", "dk_pass", "wario_shipyard", "salty_salty_speedway", "faraway_oasis", "peach_stadium", "choco_mountain", "moo_moo_meadows"]
    },
    {
        id: "dandelion_depths",
        name: "Dandelion Depths",
        icon: dandelion_depths,
        courseimg: dandelion_depths_img,
        pos: { x: 62.125, y: 36.625 },
        connections: ["boo_cinema", "starview_peak", "sky_high_sundae", "dk_pass", "cheep_cheep_falls", "moo_moo_meadows", "toads_factory", "mario_circuit", "acorn_heights"]
    },
    {
        id: "boo_cinema",
        name: "Boo Cinema",
        icon: boo_cinema,
        courseimg: boo_cinema_img,
        pos: { x: 63.125, y: 17.5 },
        connections: ["starview_peak", "dandelion_depths", "mario_circuit", "dry_bones_burnout", "acorn_heights"]
    },
    {
        id: "dry_bones_burnout",
        name: "Dry Bones Burnout",
        icon: dry_bones_burnout,
        courseimg: dry_bones_burnout_img,
        pos: { x: 38.875, y: 17.875 },
        connections: ["acorn_heights", "boo_cinema", "mario_circuit", "moo_moo_meadows", "toads_factory", "wario_stadium", "airship_fortress", "bowsers_castle"]
    },
    {
        id: "moo_moo_meadows",
        name: "Moo Moo Meadows",
        icon: moo_moo_meadows,
        courseimg: moo_moo_meadows_img,
        pos: { x: 50, y: 41 },
        connections: ["mario_circuit", "dandelion_depths", "dk_pass", "cheep_cheep_falls", "peach_stadium", "crown_city", "choco_mountain", "toads_factory", "dry_bones_burnout"]
    },
    {
        id: "choco_mountain",
        name: "Choco Mountain",
        icon: choco_mountain,
        courseimg: choco_mountain_img,
        pos: { x: 38.125, y: 51.625 },
        connections: ["toads_factory", "moo_moo_meadows", "cheep_cheep_falls", "peach_stadium", "crown_city", "whistlestop_summit", "mario_bros_circuit", "shy_guy_bazaar", "wario_stadium", "bowsers_castle"]
    },
    {
        id: "toads_factory",
        name: "Toads Factory",
        icon: toads_factory,
        courseimg: toads_factory_img,
        pos: { x: 38.75, y: 35.25 },
        connections: ["dry_bones_burnout", "acorn_heights", "mario_circuit", "dandelion_depths", "moo_moo_meadows", "peach_stadium", "choco_mountain", "mario_bros_circuit", "wario_stadium", "airship_fortress", "bowsers_castle"]
    },
    {
        id: "bowsers_castle",
        name: "Bowser's Castle",
        icon: bowsers_castle,
        courseimg: bowsers_castle_img,
        pos: { x: 26.575, y: 19.575 },
        connections: ["dry_bones_burnout", "mario_circuit", "toads_factory", "choco_mountain", "wario_stadium", "airship_fortress"]
    },
    {
        id: "acorn_heights",
        name: "Acorn Heights",
        icon: acorn_heights,
        courseimg: acorn_heights_img,
        pos: { x: 49.625, y: 11.625 },
        connections: ["boo_cinema", "dandelion_depths", "mario_circuit", "toads_factory", "dry_bones_burnout"]
    },
    {
        id: "mario_circuit",
        name: "Mario Circuit",
        icon: mario_circuit,
        courseimg: mario_circuit_img,
        pos: { x: 50, y: 26.5 },
        connections: ["acorn_heights", "boo_cinema", "starview_peak", "dandelion_depths", "moo_moo_meadows", "peach_stadium", "toads_factory", "bowsers_castle", "dry_bones_burnout"]
    },
    {
        id: "peach_stadium",
        name: "Peach Stadium",
        icon: peach_stadium,
        courseimg: peach_stadium_img,
        pos: { x: 50.2, y: 56 },
        connections: ["moo_moo_meadows", "cheep_cheep_falls", "faraway_oasis", "koopa_troopa_beach", "crown_city", "choco_mountain", "toads_factory", "rainbow_road"]
    },
    {
        id: "rainbow_road",
        name: "Rainbow Road",
        icon: rainbow_road,
        courseimg: rainbow_road_img,
        pos: { x: 49.375, y: 69 },
        connections: []
    }
];


// Create a Map for quick lookup by ID
const trackMap = new Map();
track_list.forEach(track => {
    trackMap.set(track.id, track);
});

export const getTrackById = (id) => trackMap.get(id);
export default track_list;